import React, { useEffect, useState } from "react";
import { IoMdAdd, IoMdRemove } from "react-icons/io";
import Notification from "../../../components/ui-elements/Notification";
import { IS_LOCAL_ENV } from "../../../App";
import CustomInput from "../../../components/CustomInput";
import {
  createProductSubClass,
  relateClassToSubClass,
  updateProductSubClass,
  uploadProductSubClassImage,
  deleteProductSubClassImage,
} from "../../../services/productClass";
import SlateEditor from "../../../components/slateEditor/SlateEditor";

const ProductSubClassForm = ({
  handleClose,
  loadToParent,
  prevData,
  classId,
}) => {
  const [imgFile, setImgFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    name: prevData?.name || "",
    class: prevData?.class || "", //id de clase
    code: prevData?.code || "",
    description: prevData?.description || "",
    longDescription: prevData?.longDescription || "",
    details: prevData?.details || "", //RICHTEXT
    mainSpecs: prevData?.mainSpecs || [],
    otherSpecs: prevData?.otherSpecs || [],
    //image: prevData?.image.id || "",
  });

  //MAIN SPECS SON LAS ESPECIFICACIONES PRINCIPALES DEL PRODUCTO.
  //ESTAS SE USARAN PARA APLICAR LOS FILTROS EN EL E-COMMERCE
  //OTRAS ESPECIFICACIONES SON LAS QUE SE MOSTRARAN EN LA VISTA DE DETALLE DEL PRODUCTO, JUNTO CON LAS MAIN SPECS EN EL APARTADO ESPECIFICACIONES

  const [mainSpecs, setMainSpecs] = useState(prevData?.mainSpecs || []);
  const [otherSpecs, setOtherSpecs] = useState(prevData?.otherSpecs || []);

  const addMainSpec = (specName) => {
    let newSpec = { name: specName, options: [] };
    setMainSpecs([...mainSpecs, newSpec]);
  };

  const addOptionToMainSpec = (specIndex, option) => {
    let newSpecs = [...mainSpecs];
    newSpecs[specIndex].options.push(option);
    setMainSpecs(newSpecs);
  };

  const removeOptionFromMainSpec = (specIndex, optionIndex) => {
    let newSpecs = [...mainSpecs];
    newSpecs[specIndex].options.splice(optionIndex, 1);
    setMainSpecs(newSpecs);
  };

  const removeMainSpec = (specIndex) => {
    let newSpecs = [...mainSpecs];
    newSpecs.splice(specIndex, 1);
    setMainSpecs(newSpecs);
  };

  const addOtherSpec = (specName) => {
    //let newSpec = {name:specName, value:""};
    setOtherSpecs([...otherSpecs, specName]);
  };

  const removeOtherSpec = (specIndex) => {
    let newSpecs = [...otherSpecs];
    newSpecs.splice(specIndex, 1);
    setOtherSpecs(newSpecs);
  };

  const [categoriesNumber, setCategoriesNumber] = useState(
    prevData?.categories?.length - 1 || -1
  );

  const handleDetailsChange = (data) => {
    console.log("data", data);
    setFormData((prev) => ({ ...prev, details: data }));
  };

  const onChangeSomeValue = (newVal, field, subfield) => {
    let temp = { ...formData };
    if (subfield) temp[field][subfield] = newVal;
    else temp[field] = newVal;
    setFormData(temp);
  };

  const validateAddCategory = () => {
    if (formData?.categories[formData.categories.length - 1]?.category == "") {
      return false;
    }
    return true;
  };

  const onChangeSomeValueCategory = (newVal, pos) => {
    let temp = [...formData.categories];
    temp[pos].category = newVal; // Asegúrate de actualizar el campo correcto
    setFormData((prev) => ({ ...prev, categories: temp }));
  };

  const handleFileChange = (e, type) => {
    const selectedFile = e.target.files[0]; // Obtén el primer archivo seleccionado
    if (selectedFile) {
      // Verifica si el archivo es un PDF
      if (selectedFile.type.startsWith("image/") && type == "mainImage") {
        setImgFile(selectedFile);
      } else {
        Notification({
          title: "Operación inválida",
          text: "Por favor selecciona una imagen.",
          type: "Error",
        });
      }
    }
  };

  const validForm = () => {
    let valid =
      formData.name != "" &&
      formData.description != "" &&
      formData.details != "";
    if (!prevData) {
      valid = valid && imgFile != null;
    }
    return valid;
  };

  const handleSubmit = () => {
    if (validForm()) {
      setUploading(true);
      const uploadData = async () => {
        try {
          let newImgId = null;
          if (imgFile != null) {
            //eliminar imagen anterior en caso exista
            if (prevData) await deleteProductSubClassImage(prevData.image.id);
            //cargar nueva imagens
            const resim = await uploadProductSubClassImage({
              alt: imgFile.name,
              file: imgFile,
            });
            newImgId = resim.id;
          }
          if (newImgId != null) formData.image = newImgId;

          //Preparar los datos a enviar

          formData.class = classId;
          console.log("data a enviar", formData);
          let response;

          if (prevData) {
            response = await updateProductSubClass(prevData.id, formData);
          } else {
            response = await createProductSubClass(formData);
            //await relateClassToSubClass(classId, response.id);
          }

          Notification({
            title: "Operación completada",
            text: `Se ${
              prevData ? "actualizó" : "creó"
            } la subclase de producto`,
            type: "Success",
          });
          if (prevData) loadToParent(response, prevData.id);
          else loadToParent(response);
          setUploading(false);
          handleClose();
        } catch (err) {
          IS_LOCAL_ENV && console.error(err);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
          setUploading(false);
        }
      };
      uploadData();
    } else {
      Notification({
        title: "Operación inválida",
        text: "Datos incompletos",
        type: "Error",
      });
    }
  };

  return (
    <div className="flex flex-col md:p-4 p-2 items-center">
      <h3 className="modalTitle text-dark-green ">
        {prevData ? "Actualizar " : "Crear "}subclase de producto
      </h3>
      <form className="w-full py-2 flex flex-wrap items-start gap-2">
        <CustomInput
          //customMaxW={"max-w-[300px]"}
          title="Nombre de subclase"
          value={formData.name}
          onChange={(e) => onChangeSomeValue(e.target.value, "name")}
          placeholder="ej: Orquídea Phalaenopsis"
          inputType="text"
          required={true}
        />
        <CustomInput
          //customMaxW={"max-w-[300px]"}
          title="Código(máx 5 caracteres)"
          value={formData.code}
          onChange={(e) => onChangeSomeValue(e.target.value, "code")}
          placeholder="ej: ORQPH"
          inputType="text"
          required={true}
        />
        <CustomInput
          //customMaxW={"max-w-[400px]"}
          title="Descripción"
          value={formData.description}
          onChange={(e) => onChangeSomeValue(e.target.value, "description")}
          placeholder="Breve descripción..."
          inputType="textarea"
          required={true}
        />
        <CustomInput
          //customMaxW={"max-w-[400px]"}
          title="Descripción Larga"
          value={formData.longDescription}
          onChange={(e) => onChangeSomeValue(e.target.value, "longDescription")}
          placeholder="Descripción larga..."
          inputType="textarea"
          required={true}
        />
        {/**slate js editor example */}
        <div className="w-full resize-none px-2 py-2">
          <SlateEditor
            prevValue={
              formData.details ? JSON.stringify(formData.details) : null
            }
            editable={true}
            customMaxW={"max-w-[435px]"}
            onChangeData={handleDetailsChange}
            title="Detalles"
            required={true}
          />
        </div>

        {/**======================= */}
        {/*imagen*/}
        <div className="my-2  px-4">
          <span className="font-poppins font-bold">
            {prevData ? "Reemplazar imagen" : "Cargar imagen *"}{" "}
          </span>
          <input
            className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] flex flex-col w-full max-w-[300px] text-sm"
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "mainImage")}
          />
        </div>
      </form>
      <button
        className={` w-fit my-2 text-base rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
          uploading
            ? "bg-light-gray cursor-not-allowed"
            : "hover:bg-light-purple-600 bg-dark-purple"
        }`}
        disabled={uploading}
        type="submit"
        onClick={handleSubmit}
      >
        <div className="flex flex-row items-center">
          <span className="text-nowrap text-xl">Guardar</span>
        </div>
      </button>
    </div>
  );
};

export default ProductSubClassForm;
